import { render, staticRenderFns } from "./button-widget.vue?vue&type=template&id=9294d962&scoped=true&"
import script from "./button-widget.vue?vue&type=script&lang=js&"
export * from "./button-widget.vue?vue&type=script&lang=js&"
import style0 from "./button-widget.vue?vue&type=style&index=0&id=9294d962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9294d962",
  null
  
)

export default component.exports